/* globals document, window */
import React from "react";

const ListingContext = React.createContext({
  areaSales: [],
  listing: {},
  similar: [],
  openHouses: [],
  openIndexes: [],
  mlsApiVersion: null,
});

export const ListingProvider = ListingContext.Provider;

export const withListingContext = (Component: React$Element<*>) => (
  props: *
) => (
  <ListingContext.Consumer>
    {(listingDetailContext) => (
      <Component {...listingDetailContext} {...props} />
    )}
  </ListingContext.Consumer>
);
